// ============================================================================
// AvisoSemDado: linha discreta de página quando algum número do período não
// veio do Avec (A3 do "Dashboard sem zero silencioso", 23/10/2026). Mesmo
// estilo dos selos da tela; sem emoji e sem travessão. "Tentar de novo" refaz
// só o que faltou. Sem texto não renderiza nada.
// ============================================================================
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { TENTAR_DE_NOVO, BUSCANDO_DE_NOVO } from '../utils/textosSemDado.js';

export default function AvisoSemDado({ texto, onTentar = null, tentando = false }) {
  if (!texto) return null;
  return (
    <div role="status" className="flex items-start sm:items-center gap-2 flex-wrap rounded-md border border-warning/20 bg-warning-soft px-2.5 py-1.5 text-[11px] leading-snug text-warning-text">
      <AlertCircle size={12} className="flex-shrink-0 mt-[1px] sm:mt-0" />
      <span className="flex-1 min-w-0">{texto}</span>
      {onTentar && (
        <button
          type="button"
          onClick={onTentar}
          disabled={tentando}
          className="font-semibold underline underline-offset-2 hover:text-warning-strong disabled:opacity-60 disabled:no-underline"
        >
          {tentando ? BUSCANDO_DE_NOVO : TENTAR_DE_NOVO}
        </button>
      )}
    </div>
  );
}
